import { createApi } from '@reduxjs/toolkit/query/react';

import { ILanguage } from '../../types/interfaces/language';
import { ITranslation } from '../../types/interfaces/translation';
import { HTTP_METHOD, REDUX_CACHE, TRANSLATIONS } from '../constants';
import * as endpoints from '../endpoints';
import {
  TransformedErrorResponseWithNotification,
  getBaseQuery,
  getListProvidesTags,
} from '../generic';

export const translationsApi = createApi({
  reducerPath: 'translationsApi',
  tagTypes: [
    TRANSLATIONS.LANGUAGES,
    REDUX_CACHE.ABORT_INVALIDATION,
    REDUX_CACHE.LIST,
  ],
  baseQuery: getBaseQuery(),
  // global configuration for the api
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getLanguagesApi: builder.query<ILanguage[], void>({
      keepUnusedDataFor: 3600,
      query() {
        return {
          url: endpoints.Language.ROOT,
          method: HTTP_METHOD.GET,
          headers: {},
        };
      },
      providesTags: (result) =>
        getListProvidesTags(result, TRANSLATIONS.LANGUAGES),
      ...TransformedErrorResponseWithNotification(),
    }),
  }),
});

export const {
  useGetLanguagesApiQuery: useGetLanguages,
  useLazyGetLanguagesApiQuery: useLazyGetLanguages,
} = translationsApi;
